module.exports = __webpack_public_path__ + "static/media/muscleBack.55e84900.png";